<template>
  <div
    data-cy="access-lock"
    :class="[
      {
        '--overlay': overlay,
        '--horizontal': horizontal,
        '--locked': !isLoading,
        '--scheduled': isScheduled
      },
      'access-lock p-absolute d-flex align-items-center justify-content-center'
    ]"
  >
    <template v-if="isLoading">
      <v-loader white thin />
    </template>
    <template v-else>
      <v-icon icon="lock" size="1rem"></v-icon>
      <span
        v-if="isScheduled"
        class="d-inline-block text-small font-weight-semi-bold access-lock__time"
        >{{ timeAgo(availableAfter, true) }}</span
      >
    </template>
  </div>
</template>

<script>
import { isPresent } from "@/lib/utils"
import { timeAgo } from "@/lib/date-utils"

export default {
  props: {
    isLoading: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    availableAfter: { type: String, default: "" }
  },

  methods: {
    timeAgo
  },

  computed: {
    isScheduled() {
      return isPresent(this.availableAfter)
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import "@/assets/styles/variables";

.access-lock {
  background-color: rgba($color-rgb--grey-90, 0.24);
  backdrop-filter: blur(4px);
  color: white;
  right: $size--2;
  bottom: 4.5%;
  margin-top: -#{math.div($size--8, 2)};
  height: $size--8;
  width: $size--8;
  border-radius: $size--10;

  .v-loader {
    height: $size--4;
    width: $size--4;
  }

  &.--overlay {
    top: $size--6;
    bottom: auto;
  }

  &.--horizontal {
    right: $size--4;
    top: 50%;
    bottom: 0%;
  }

  &.--scheduled {
    width: auto;
    padding: 0 $size--1 0 $size--2;
  }
}

.access-lock__time {
  margin: 0 $size--1 2px;
}
</style>

<style lang="scss">
.access-lock {
  // Prevent button styles from making lock bigger
  .v-icon {
    transform: scale(1);
    top: 0;
  }
}
</style>
